<template>
  <nav class="breadcrumb">
    <ul>
      <li v-for="(item, index) in breadcrumbs" :key="index">
        <span v-if="item.link" 
        class='main'>{{ item.text }}</span>
        <span v-else class='main'>{{ item.text }}</span>
        <span v-if="index < breadcrumbs.length - 1"> > </span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  display: flex;
  padding-bottom: 0px;
  font-weight: 500;
  color: #444;
  font-family: TTNormsMedium, sans-serif;
}

.breadcrumb ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 0px;
}

.breadcrumb li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.breadcrumb .main {
  color: #005eb8;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3;
}

.breadcrumb li:not(:last-child)::after {
  content: "";
  color: #ccc;
}

.breadcrumb span {
  color: #666;
}
</style>
